<template>
  <b-container fluid>
      <b-row>
        <b-col lg="12" sm="12">
          <iq-card>
            <template>
              <b-row>
                <b-col lg="12" sm="12" class="text-center mb-4">
                  <h5 class='complain-title'>{{ $t('complain.complian_cycle_details') }}</h5>
                </b-col>
              </b-row>
                <b-row>
                  <b-col lg="12" sm="12">
                    <b-row>
                      <b-col lg="12" sm="12">
                        <div>
                          <b-table bordered hover :items="singleDetailsData" :fields="columns"  aria-hidden="loading | listReload ? 'true' : null">
                            <template v-slot:cell(index)="data">
                              {{ $n(data.index+1) }}
                            </template>
                            <template v-slot:cell(com_title)="data">
                              <span class="capitalize">{{ data.item.com_title }}</span>
                            </template>
                            <template v-slot:cell(sender_name)="data">
                              <span class="capitalize">{{ data.item.sender_name }}</span>
                            </template>
                            <template v-slot:cell(sender_designation)="data">
                              <span class="capitalize">{{ data.item.sender_designation }}</span>
                            </template>
                            <template v-slot:cell(receiver_name)="data">
                              <span class="capitalize">{{ data.item.receiver_name }}</span>
                            </template>
                            <template v-slot:cell(receiver_designation)="data">
                              <span class="capitalize">{{ data.item.receiver_designation }}</span>
                            </template>
                          </b-table>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </b-container>
</template>
<script>
// import { commonServiceBaseUrl } from '../../../../../config/api_config'
import RestApi, { commonServiceBaseUrl, authServiceBaseUrl } from '../../../../../config/api_config'
// import { getCommitteeList, getCommitteeReport } from '../../api/routes'
export default {
  name: 'FormLayout',
  props: ['id', 'complain_id', 'item'],
  created () {
    if (this.id) {
      const tmp = this.getComplainReceiveDetails()
      this.complain_detail = tmp
    }
    this.singleDetailsData = this.item
  },
  data () {
    return {
      complain_detail: [],
      slOffset: 1,
      base_url: commonServiceBaseUrl,
      singleDetailsData: ''
    }
  },
  computed: {
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('complain.sender_name'), class: 'text-left' },
          { label: this.$t('complain.sender_designation'), class: 'text-left' },
          { label: this.$t('complain.receiver_name'), class: 'text-left' },
          { label: this.$t('complain.receiver_designation'), class: 'text-left' },
          { label: this.$t('complain.com_title'), class: 'text-justify' },
          { label: this.$t('complain.description'), class: 'text-justify' },
          { label: this.$t('complain.note'), class: 'text-justify' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'sender_name_bn' },
          { key: 'sender_designation_bn' },
          { key: 'receiver_name_bn' },
          { key: 'receiver_designation_bn' },
          { key: 'com_title_bn' },
          { key: 'description_bn' },
          { key: 'note_bn' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'sender_name' },
          { key: 'sender_designation' },
          { key: 'receiver_name' },
          { key: 'receiver_designation' },
          { key: 'com_title' },
          { key: 'description' },
          { key: 'note' }
        ]
      }
      return labels.map((item, index) => {
        return Object.assign(item, keys[index])
      })
    }
  },
  methods: {
    getComplainInfo () {
      return this.$store.state.Complain.complainSends.find(item => item.id === this.id)
    },
    getComplainReceiveDetails () {
      RestApi.getData(commonServiceBaseUrl, 'complain-send/detailList/' + this.complain_id).then(response => {
        this.formatList(response.data)
      })
    },
    formatList (data) {
      RestApi.getData(authServiceBaseUrl, 'user/getAllUser').then(response => {
        const designationList = this.$store.state.commonObj.designationList
        this.singleDetailsData = data.map(item => {
          const senderUserData = response.data.find(user => user.user_id === item.sender_id)
          const receiverUserData = response.data.find(user => user.user_id === item.receiver_id)
          const senderDesignation = designationList.find(designation => designation.value === senderUserData.designation_id)
          const receiverDesignation = designationList.find(designation => designation.value === receiverUserData.designation_id)
          const designationData = {
            sender_name: senderUserData.name,
            sender_name_bn: senderUserData.name_bn,
            receiver_name: receiverUserData.name,
            receiver_name_bn: receiverUserData.name_bn,
            sender_designation: senderDesignation.text_en,
            sender_designation_bn: senderDesignation.text_bn,
            receiver_designation: receiverDesignation.text_en,
            receiver_designation_bn: receiverDesignation.text_bn
          }
          return Object.assign({}, item, designationData)
        })
      })
    },
    getComplainSendItem () {
      this.complainSendItem = this.item
    }
  }
}
</script>
<style>
  .hidden_header {
    display: none
  }
  .card-border {
    border: 1px solid #b9bdc1;
    box-shadow: 1px 1px 6px -1px grey;
    background-color: #dee2e6;
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .report-name{
    font-weight: bold !important;
    text-transform: uppercase;
  }
  .my-btn{
    padding: 2px !important;
  }
</style>
